/**
 * @generated SignedSource<<95debf0d605835e7bf4d0316e73cc304>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type perspectiveSwitcher_Query$variables = Record<PropertyKey, never>;
export type perspectiveSwitcher_Query$data = {
  readonly perspectives: ReadonlyArray<{
    readonly id: string;
    readonly name: string;
  }>;
};
export type perspectiveSwitcher_Query = {
  response: perspectiveSwitcher_Query$data;
  variables: perspectiveSwitcher_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Perspective",
    "kind": "LinkedField",
    "name": "perspectives",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "perspectiveSwitcher_Query",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "perspectiveSwitcher_Query",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "fa870d00ed9e03aa78cd3ccdeaa69fba",
    "id": null,
    "metadata": {},
    "name": "perspectiveSwitcher_Query",
    "operationKind": "query",
    "text": "query perspectiveSwitcher_Query {\n  perspectives {\n    id\n    name\n  }\n}\n"
  }
};
})();

(node as any).hash = "9c9a54f9f1bec87110125a370238cdb6";

export default node;
